"use strict";

import angular from "angular";

angular.module("nucont.accountings", ["nucont.shared"]);
require("./accountings.routes");
